module.exports = __webpack_public_path__ + "platform-web/static/media/dropdown-arrow.6f38a3e4.svg";